require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var WPGPreformattedBlock = function WPGPreformattedBlock(props) {
  var innerHTML = props.innerHTML;
  return React.createElement("div", {
    className: "wpg-block wpg-b_preformatted",
    dangerouslySetInnerHTML: {
      __html: innerHTML
    }
  });
};

exports["default"] = WPGPreformattedBlock;